import { render } from "./Registro04FP.vue?vue&type=template&id=e2b1ae32&scoped=true"
import script from "./Registro04FP.vue?vue&type=script&lang=js"
export * from "./Registro04FP.vue?vue&type=script&lang=js"

import "@/assets/css/registro04FP.css?vue&type=style&index=0&id=e2b1ae32&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2b1ae32"]])

export default __exports__